import React from 'react';
import { Button, Result, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import UrlRankPage from '../Pages/UrlRankPage';
import { useAppSelector } from '../Modules/Presentation/hooks';
import { selectUser } from '../Modules/User/Presentation/selectors';

const UrlRankRoutes = () => {
  const navigate = useNavigate();
  const currentUser = useAppSelector(selectUser);

  if (!currentUser) {
    return <Spin style={{ display: 'block', margin: '120px auto' }} />;
  }

  if (currentUser.grade !== 'ADMIN') {
    return (
      <Result
        status="403"
        title="접근 권한이 없습니다"
        subTitle="이 페이지는 관리자만 접근할 수 있습니다."
        extra={
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: 6, padding: '0 32px' }}
            onClick={() => navigate('/')}
          >
            홈으로 이동
          </Button>
        }
      />
    );
  }

  return <UrlRankPage />;
};

export default UrlRankRoutes;
